export default {
    methods: {
        betAuthorBlocked(authorId, blockedUserIds) {
            return blockedUserIds.includes(Number(authorId));
        },
        blockAuthor(authorId, blockedUserIds) {
            blockedUserIds.push(Number(authorId));
        },
        unblockAuthor(authorId, blockedUserIds) {
            let index = blockedUserIds.findIndex(userId => userId === Number(authorId));
            this.blockedUserIds.splice(index, 1);
        },
        followAuthor(authorId, followedUserIds) {
            followedUserIds.push(Number(authorId));
        },
        unfollowAuthor(authorId, followedUserIds) {
            let index = followedUserIds.findIndex(userId => userId === Number(authorId));
            followedUserIds.splice(index, 1);
        },
    },
}